import { useEffect } from "react";
import { selectCurrentRoom } from "store/rooms";
import { selectIsCurrentUserInTutorial } from "modules/userStatus/redux/selectors";
import { useSelector } from "react-redux";
import { selectIsWhiteboardEnabled } from "modules/event/selectors";
import { selectIsMobile } from "modules/deviceInfo";
import { setLayout } from "modules/audioVideo/redux/slice";
import { DisplayLayout } from "modules/audioVideo";
import { useAppDispatch } from "store/hooks";
import { usePrevious } from "helpers/reactHooksUtils";
import RoomWhiteboardSubscriber from "./RoomWhiteboardSubscriber";
import { selectIsRoomWhiteboardOpen } from "./redux/selectors";

export const RoomWhiteboardContainer = () => {
  const dispatch = useAppDispatch();
  const currentRoom = useSelector(selectCurrentRoom);
  const isMeInTutorial = useSelector(selectIsCurrentUserInTutorial);
  const isWhiteboardEnabled = useSelector(selectIsWhiteboardEnabled);
  const isWhiteboardOpen = useSelector(selectIsRoomWhiteboardOpen);
  const isMobileView = useSelector(selectIsMobile);
  const previousIsWhiteboardOpen = usePrevious(isWhiteboardOpen);

  useEffect(() => {
    if (previousIsWhiteboardOpen === isWhiteboardOpen) return;

    if (isWhiteboardOpen) {
      dispatch(setLayout(DisplayLayout.Focus));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWhiteboardOpen]);

  if (isMeInTutorial || isMobileView || !currentRoom || !isWhiteboardEnabled) {
    return null;
  }

  return <RoomWhiteboardSubscriber key={currentRoom.id} />;
};
